(function () {
    const topBarButtons = document.querySelectorAll('.js-top-bar-navigation-toggle');
    const topBarButtonNavs = document.querySelectorAll('.top-bar-button-navigation-wrapper');

    const resetButtonNavs = function () {
        topBarButtons.forEach(button => button.classList.remove('active'));
        topBarButtonNavs.forEach(nav => nav.classList.remove('block'));
    }

    topBarButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            const shouldOpen = !this.classList.contains('active');

            resetButtonNavs();

            if (shouldOpen) {
                this.classList.add('active');

                const navigationId = this.getAttribute('href').replace('#', '');
                const navigationWrapper = document.querySelectorAll(
                    `.top-bar-button-navigation-wrapper[data-top-bar-navigation-id="${navigationId}"]`
                );

                if (navigationWrapper) {
                    navigationWrapper.forEach(nav => nav.classList.add('block'));
                }
            }
        });
    });

    // Handle clicks outside the navcontainer to close open navcontainers
    document.body.addEventListener('click', function (e) {
        const target = e.target;
        if (target.closest('.top-bar-button-navigation-wrapper') ||
            target.closest('.js-top-bar-navigation-toggle')) {
            return;
        }
        resetButtonNavs();
    });
}())